import { render, staticRenderFns } from "./salary-table.vue?vue&type=template&id=52f7bf7c"
import script from "./salary-table.vue?vue&type=script&lang=js"
export * from "./salary-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports